import { XMLBaseParser } from '../../../utils/XMLBaseParser';
import { FormsAuthenticateResponse } from '../data/FormsAuthenticateResponse';
import { authErrorString, FormsAuthResponseParseError } from '../../AuthErrors';
import { Logger } from '../../Logger';
import { logConstants } from '../../../utils/Constants';

export class FormsAuthenticateResponseParser extends XMLBaseParser<FormsAuthenticateResponse> {
	readonly SUCCESS = 'success';
	readonly FAIL = 'fail';
	private xml: string;

	parseXML(xml: string): FormsAuthenticateResponse {
		this.xml = xml;
		// parseXML of base class calls abstract method processParsedXML
		return super.parseXML(xml);
	}

	processParsedXML(json: any): FormsAuthenticateResponse {
		const status = json.AuthenticateResponse.Status;
		const result = json.AuthenticateResponse.Result;
		if (status != this.SUCCESS || result === this.FAIL) {
			Logger.getInstance().write(
				logConstants.ERROR,
				authErrorString.DSAUTH_FORMS_RESPONSE_NOT_SUCCESSFUL +
					'. AuthenticateResponse received : ' +
					JSON.stringify(json)
			);
			throw new FormsAuthResponseParseError(
				`${authErrorString.DSAUTH_FORMS_RESPONSE_NOT_SUCCESSFUL}. Status: ${status}, Result: ${result}`
			);
		}

		return new FormsAuthenticateResponse(
			json.AuthenticateResponse.Status,
			json.AuthenticateResponse.Result,
			json.AuthenticateResponse.AuthenticationRequirements.PostBack,
			json.AuthenticateResponse.AuthenticationRequirements.CancelPostBack,
			json.AuthenticateResponse.StateContext?.__text ?? '',
			this.xml
		);
	}
}
